import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.other');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'wiz-page-other',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.other/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageOtherComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public category: string = '';
    public sub: string = '';
    public routerSub: any;

    // 공지사항
    public notices: any[] = [];
    public noticeTotal: number = 0;
    public noticePage: number = 1;
    public noticeDetail: any = null;

    // 게시판
    public posts: any[] = [];
    public postTotal: number = 0;
    public postPage: number = 1;
    public postSearch: string = '';
    public postForm: any = {};
    public postEditing: boolean = false;
    public postDetail: any = null;
    public postComments: any[] = [];
    public commentForm: any = { content: '' };

    public categories: any = {
        'cash': {
            label: '금전처리',
            items: ['계정관리', '금전현황', '돈통오픈기록']
        },
        'attendance': {
            label: '근태관리',
            items: ['근태관리', '월근태내역', '시급관리']
        },
        'sms': {
            label: 'SMS관리',
            items: ['메세지관리', '문자전송현황', 'SMS충전', 'SMS충전내역', 'SMS자동전송관리', 'SMS기념일전송관리', 'SMS주문취소전송관리']
        }
    };

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.updateRoute();
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                await this.updateRoute();
                await this.service.render();
            }
        });
        await this.service.render();
    }

    ngOnDestroy() { if (this.routerSub) this.routerSub.unsubscribe(); }

    private async updateRoute() {
        const seg = WizRoute.segment;
        this.category = seg.category || 'cash';
        try { this.sub = seg.sub ? decodeURIComponent(seg.sub) : ''; } catch { this.sub = seg.sub || ''; }
        if (!seg.category) {
            this.service.href('/other/cash');
            return;
        }
        if (this.sub) await this.loadSubData();
    }

    public categoryKeys(): string[] { return Object.keys(this.categories); }
    public isActiveCat(key: string): boolean { return this.category === key; }

    public async selectSub(item: string) {
        this.service.href(`/other/${this.category}/${encodeURIComponent(item)}`);
    }

    private async loadSubData() {
        this.noticeDetail = null;
        this.postDetail = null;
        if (this.sub === '공지사항') await this.loadNotices();
        if (this.sub === '게시판') await this.loadPosts();
    }

    // ===== 공지사항 =====
    public async loadNotices() {
        let res = await wiz.call("notice_list", { page: this.noticePage });
        if (res.code === 200) { this.notices = res.data?.data || []; this.noticeTotal = res.data?.total || 0; }
    }

    public async viewNotice(id: string) {
        let res = await wiz.call("notice_get", { id });
        if (res.code === 200) this.noticeDetail = res.data;
        await this.service.render();
    }

    public async backToNoticeList() {
        this.noticeDetail = null;
        await this.service.render();
    }

    // ===== 게시판 =====
    public async loadPosts() {
        let res = await wiz.call("board_list", { text: this.postSearch, page: this.postPage });
        if (res.code === 200) { this.posts = res.data?.data || []; this.postTotal = res.data?.total || 0; }
    }

    public async viewPost(id: string) {
        let res = await wiz.call("board_get", { id });
        if (res.code === 200) {
            this.postDetail = res.data;
            this.postComments = res.data?.comments || [];
        }
        this.postEditing = false;
        await this.service.render();
    }

    public async backToPostList() {
        this.postDetail = null;
        this.postEditing = false;
        await this.loadPosts();
        await this.service.render();
    }

    public async newPost() {
        this.postForm = { title: '', content: '', category: '일반' };
        this.postEditing = true;
        this.postDetail = null;
        await this.service.render();
    }

    public async editPost() {
        this.postForm = JSON.parse(JSON.stringify(this.postDetail));
        this.postEditing = true;
        this.postDetail = null;
        await this.service.render();
    }

    public async savePost() {
        let res = await wiz.call("board_save", this.postForm);
        if (res.code === 200) {
            this.postEditing = false;
            await this.loadPosts();
            await this.service.render();
        } else {
            await this.service.modal.show({ title: '', message: res.data?.message || '저장 실패', cancel: false, action: '확인', status: 'error' });
        }
    }

    public async deletePost(id: string) {
        let confirm = await this.service.modal.show({ title: '', message: '삭제하시겠습니까?', action: '삭제', status: 'error' });
        if (!confirm) return;
        await wiz.call("board_delete", { id });
        this.postDetail = null;
        await this.loadPosts();
        await this.service.render();
    }

    // ===== 댓글 =====
    public async saveComment() {
        if (!this.commentForm.content) return;
        this.commentForm.post_id = this.postDetail.id;
        let res = await wiz.call("comment_save", this.commentForm);
        if (res.code === 200) {
            this.commentForm = { content: '' };
            await this.viewPost(this.postDetail.id);
        }
    }

    public async deleteComment(id: string) {
        await wiz.call("comment_delete", { id });
        await this.viewPost(this.postDetail.id);
    }
}

export default PageOtherComponent;